import { checkIsExtension } from "./helpers";
export const PACVUE_TOKENS_KEY = "PACVUE_TOKENS";
/**
 * localstorage wrapper function
 */
function get(key) {
    if (checkIsExtension()) {
        return new Promise((resolve) => {
            try {
                chrome?.storage?.local?.get([key], (value) => {
                    resolve(value[key] ?? null);
                });
            }
            catch {
                resolve(null);
            }
        });
    }
    else {
        const str = localStorage.getItem(key);
        try {
            return str ? JSON.parse(str) : null;
        }
        catch {
            return null;
        }
    }
}
function set(key, value) {
    if (checkIsExtension()) {
        return chrome.storage.local.set({ [key]: value });
    }
    else {
        localStorage.setItem(key, JSON.stringify(value));
    }
}
/**
 * save Pacvue token for later reference.
 */
export async function savePacvueTokenToLocalStorage(accountId, token) {
    try {
        validateToken(token);
        const tokens = (await get(PACVUE_TOKENS_KEY)) || {};
        tokens[accountId] = token;
        await set(PACVUE_TOKENS_KEY, tokens);
    }
    catch {
        // fail silently
    }
}
function validateToken(token) {
    const { pacvueToken, pacvueRefreshToken, pacvueTokenExpiresIn, pacvueTokenCreatedAt } = token || {};
    if (!(pacvueToken && pacvueRefreshToken && pacvueTokenExpiresIn && pacvueTokenCreatedAt)) {
        throw new Error("invalid pacvue token");
    }
}
/**
 * get Pacvue token from local storage
 */
export async function getPacvueTokenFromLocalStorage(accountId) {
    try {
        const tokens = await get(PACVUE_TOKENS_KEY);
        return tokens?.[accountId] ?? null;
    }
    catch {
        return null;
    }
}
